module.exports = __webpack_public_path__ + "img/activity-bigcover.5eb24dca.png";